window.onload=function(){
	const objects = document.querySelectorAll('.scroll-fadeup');
	const cb = function(entries, observer) {
	    entries.forEach(entry => {
	        if(entry.isIntersecting) {
	            entry.target.classList.add('imgfadeup');//スクロール感知で「imgfadeup」のクラス名を付与
	            observer.unobserve(entry.target); //監視の終了
	        }
	    });
	}
	const options = {
	    root: null,
	    rootMargin: "0px",
	    threshold: 0
	}
	const io = new IntersectionObserver(cb, options);
	objects.forEach(object => {
	    io.observe(object);
	});


	const objects3 = document.querySelectorAll('.scroll-fadeinleft');
	const cb3 = function(entries, observer) {
	    entries.forEach(entry => {
	        if(entry.isIntersecting) {
	            entry.target.classList.add('imgfadeinleft');//スクロール感知で「imgfadeinleft」のクラス名を付与
	            observer.unobserve(entry.target); //監視の終了
	        }
	    });
	}
	const options3 = {
	    root: null,
	    rootMargin: "0px",
	    threshold: 0
	}
	const io3 = new IntersectionObserver(cb3, options3);
	objects3.forEach(object => {
	    io3.observe(object);
	});

  
	const objects2 = document.querySelectorAll('.zoom-in');
	const cb2 = function(entries, observer) {
	    entries.forEach(entry => {
	        if(entry.isIntersecting) {
	            entry.target.classList.add('imgzoomin');//スクロール感知で「imgzoomin」のクラス名を付与
	            observer.unobserve(entry.target); //監視の終了
	        }
	    });
	}
	const options2 = {
	    root: null,
	    rootMargin: "0px",
	    threshold: 0
	}
	const io2 = new IntersectionObserver(cb2, options2);
	objects2.forEach(object => {
	    io2.observe(object);
	});
}